import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
import constants from './constants';
const { getPaddingStyles, } = styleService.utils;
export const LeftArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/3df01759-af0c-4d81-b2f7-f61577ac3807.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  left: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
export const LeftArrowWrapper = styled.div `
  height: 100%;
  width: 90px;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1;
  @media only screen  and (min-width : 1600px) {
    ${({ isDesktop }) => (isDesktop && `
        left: -48px;
    `)};
`;
export const RightArrowWrapper = styled.div `
  height: 100%;
  width: 90px;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
  @media only screen  and (min-width : 1600px) {
    ${({ isDesktop }) => (isDesktop && `
        right: -48px;
    `)};
  }
`;
export const RightArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/45d5a7b6-86eb-4850-9568-4d6ed91731fe.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  right: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
export const SlidesContainer = styled.div `
  display: flex;
  overflow: hidden;
  overflow-x: ${({ isDesktop }) => (isDesktop ? 'hidden' : 'scroll')};
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  ::-webkit-scrollbar { 
    display: none;
  }
   padding-bottom: ${({ isDesktop }) => (isDesktop ? '14px' : '0px')};
   padding-left: ${({ padding, isDesktop }) => !isDesktop && padding.left.web};
   padding-top: ${({ padding }) => padding.top.web};
   ${({ isDesktop }) => (isDesktop && `
      overflow: hidden;
      overflow-x: hidden;
      overflow-y: hidden;
      `)};
      ${({ isDesktop }) => (isDesktop && `
      margin-left: ${constants.OFFSET}px;
      margin-right: ${constants.OFFSET}px;
      `)};
      @media only screen  and (min-width : 1600px) {
        ${({ isDesktop }) => (isDesktop && `
        margin-right: 0;
        margin-left: 0;
        `)};
      }
`;
export const Container = styled.div `
  ${({ padding }) => getPaddingStyles(padding)};
  padding:0;
  padding-top: 0;
  padding-bottom: ${({ padding }) => padding.bottom.web};
  background: #${({ bkgColor }) => bkgColor};
  background: ${({ bkgColor }) => bkgColor};
  @media only screen  and (min-width : 768px) {
  
  }

  @media only screen  and (min-width : 1600px) {
    margin-left: auto;
    margin-right: auto;
    max-width: 1600px;
  }
`;
export const SlideWrapper = styled.div `
  align-items: stretch;
  flex: 0 0 auto;
  display: flex;
  width: ${({ width }) => width}%;
  margin:0px ${({ margin }) => margin} 0px 0px;
  :last-child{
    margin-right:${({ padding }) => padding.right.web};
    }
  .titles-description {
    white-space: normal;
  }
  > last-child {
    padding:0px 0px 0px 0px;
  }
  .banner-container{
    padding-bottom:0;
  }
  @media ${(props) => props.theme.mq.md} { 
    display: inline-block;
  }
`;
export const DesktopBgWrapper = styled.div `
${({ isDesktop, bkgColor }) => (isDesktop && `
    background:  ${bkgColor};
      `)};
`;
export const SectionWrapper = styled.div `
  padding-left: ${({ padding }) => padding.left.web};
  padding-right: ${({ padding }) => padding.right.web};
  ${({ isDesktop }) => (isDesktop && `
  padding-left: ${constants.OFFSET}px;
  padding-right: ${constants.OFFSET}px;
  `)};
  @media only screen  and (min-width : 1600px) {
    ${({ isDesktop }) => (isDesktop && `
    padding-left: 0;
    padding-right: 0;
    `)};
  }
`;
